var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('product-template',{attrs:{"product":_vm.product,"likes":_vm.likes,"oneShot":_vm.product.isOneShotable,"inCart":true,"initQuantity":0,"status":_vm.PRODUCT_STATUS.shelf,"showFreq":true,"withLikes":_vm.authenticated}})}
var staticRenderFns = []

export { render, staticRenderFns }